import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ProviderManager from '../../../provider/providerManager';
import PopUp from "../../Shared/Popup/PopUp";
import ThirdPartyAgreementsData from './ThirdPartyAgreementsData';

const ThirdPartyAgreementsPopup = (props) => {
  const [showThirdPartyPopup, setShowThirdPartyPopup] = useState(false);
  const [isAllowedToShowPopup, setIsAllowedToShowPopup] = useState(false);
  const [hasThirdPartyPopUpBeenShown, setHasThirdPartyPopUpBeenShown] = useState(sessionStorage.getItem('thirdPartyPopupHasBeenShown') === 'true');
  let pageLoadCounter = parseInt(sessionStorage.getItem('pageLoadCounter')) || 0;
  let selfCareCounter = parseInt(sessionStorage.getItem('selfCareCounter')) || 0;
  var data = props.iContent;

  if(!props.isFetchData){
    return null;
  }

  useEffect(() => {
    if(pageLoadCounter > 3 && selfCareCounter < 3 )
    {
        const collaborationApproval = props.hasConfirmCollaborationApproval;
        const isCheckboxFlagIsOn = !!data.thirdPartyCheckBox.value;
        if(isCheckboxFlagIsOn && (collaborationApproval === false) && !hasThirdPartyPopUpBeenShown){
            if(!isAllowedToShowPopup){
                (async  () => {
                    var isAllowedToShowPopup = await ProviderManager.getProviderData('isAllowedToShowThirdPartyPopup', []);
                    setIsAllowedToShowPopup(isAllowedToShowPopup.Body);
                })();
            }
        }
    }
  }, [props.hasConfirmCollaborationApproval]);


  useEffect(() => {
    if(isAllowedToShowPopup)
    {
        setShowThirdPartyPopup(true);
        sessionStorage.setItem('thirdPartyPopupHasBeenShown', true);
        setHasThirdPartyPopUpBeenShown(true);   
    }
  }, [isAllowedToShowPopup]);


  return (
       <div className='third-party-popup-main'>
          <PopUp showPopUp={showThirdPartyPopup} onClose={() => setShowThirdPartyPopup(false)}>
                  <ThirdPartyAgreementsData data={data}  onClosePopup={() => setShowThirdPartyPopup(false)} />
          </PopUp>
      </div>
  );

};

const mapStateToProps = state => {
  return {
    isFetchData: state.selfcarePage?.isFetchData,
    hasConfirmCollaborationApproval : state.selfcarePage?.selfCareData?.collaborationApproval,
  };
};

export default connect(mapStateToProps, null)(ThirdPartyAgreementsPopup);
